/* unplugin-vue-components disabled */import { render } from "./faqComponent.vue?vue&type=template&id=1a105657&scoped=true"
import script from "./faqComponent.vue?vue&type=script&lang=js"
export * from "./faqComponent.vue?vue&type=script&lang=js"

import "./faqComponent.vue?vue&type=style&index=0&id=1a105657&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a105657"]])

export default __exports__